import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VolumeOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"volume_off"}/>
}
